module.exports = __webpack_public_path__ + "img/journal-of-the-american-philosophical-association-cover.cb79b572.jpg";